module.exports = __webpack_public_path__ + "img/amjsAnimation1.b358f186.png";